/** misc 分包业务文案 — English (merged into global i18n on demand) */
export default {
  misc: {
    nav: {
      travelHub: 'Travel',
      travelSearch: 'Travel Search',
      myOrders: 'My orders',
      orderSearch: 'Search orders',
      orderFill: 'Confirm order',
    },
    orderFill: {
      invalidTitle: 'Order information expired',
      invalidDesc:
        'Your checkout details may have expired. Please go back and select the product again.',
      back: 'Back',
    },
    date: {
      today: 'Today',
      tomorrow: 'Tomorrow',
      dayAfterTomorrow: 'Day after tomorrow',
      monthDay: '{month}/{day}',
      weekdaySun: 'Sun',
      weekdayMon: 'Mon',
      weekdayTue: 'Tue',
      weekdayWed: 'Wed',
      weekdayThu: 'Thu',
      weekdayFri: 'Fri',
      weekdaySat: 'Sat',
    },
    travelHub: {
      loading: 'Loading…',
      domestic: 'Domestic',
      international: 'International',
      locatedPrefix: 'Located at ',
      switchToLocatedCity: 'Switch',
      priceStar: 'Price & stars',
      proximityPrefix: 'Find hotels within ',
      proximityPlaceholder: 'Enter a location',
      proximityMid: ' near ',
      proximityRadius: '5 km',
      proximitySuffix: '?',
      searchHistory: 'Recent searches',
      searchHotel: 'Search hotels',
      searchTrain: 'Search trains',
      searchFlight: 'Search flights',
      flightDomestic: 'Flights',
      flightInternational: 'Intl. flights',
      flightOneway: 'One-way',
      flightRoundtrip: 'Round-trip',
      flightMultiple: 'Multi-city',
      flightEconomy: 'Economy',
      flightBusiness: 'Business/First',
      flightAirline: 'Airline',
      noAirlineLimit: 'Any airline',
      flightFromHint: 'From',
      flightToHint: 'To',
      trainTitle: 'China rail tickets',
      trainComingSoon: 'Train tickets are not yet available. Please stay tuned.',
      trainFromHint: 'From station',
      trainToHint: 'To station',
      trainHighSpeed: 'High-speed rail',
      tabOrders: 'Orders',
      unsupportedTitle: 'Unsupported environment',
      unsupportedDesc: 'Please open this page in UnionPay or a browser',
      errorTitle: 'Unable to open',
      errorDesc: 'Please sign in and make sure your phone number is available, then try again',
      retry: 'Retry',
      comingSoon: 'Coming soon',
      locationFailedPrefix: 'Location failed, defaulting to ',
      locating: 'Locating…',
      trainNoService: 'No trains for this city. Try another city',
      flightNoService: 'No flights for this city. Try another city',
      flightTipsTitle: 'Flight tips',
      flightTipsHint: 'Your guide to smoother trips',
      flightTipsMore: 'More',
      oneNight: '1 night',
      nights: '{count} nights',
      guestsAdultsChildren: '{adult} adult(s), {child} child(ren)',
      flightPassengers: '{adult} adult(s) {child} child(ren) {infant} infant(s)',
      roundtripDays: '{count} day(s)',
      trainExpertTitle: 'Rail travel experts',
      selectDestCity: 'Please select destination',
      sameOriginDest: 'Origin and destination cannot be the same',
      intlMainlandBoth: 'Origin and destination cannot both be cities in mainland China',
      selectCityFirst: 'Please select a city first',
      addLeg: 'Add leg',
      addLegTip: 'Up to 5 legs',
      selectCity: 'Select city',
      delLegConfirm: 'Delete this leg?',
      withChild: 'With child',
      withInfant: 'With infant',
      childAgeRange: 'Ages 2–12',
      infantAgeRange: '14 days–2 years',
      selectPassengers: 'Select passengers',
      passengerAdult: 'Adult',
      passengerChild: 'Child',
      passengerInfant: 'Infant',
      passengerAdultDesc: 'Age 12+',
      passengerChildDesc: 'Ages 2–12',
      passengerInfantDesc: '14 days–2 years',
      passengerDone: 'Done',
      hotelScore: '{score}',
      hotelDistance: '{distance} km away',
      hotelPriceFrom: 'from',
      hotelNoPrice: 'No price',
      hotelSearchPlaceholder: 'Location / Hotel',
      channel: {
        hotel: 'Hotels',
        train: 'Trains',
        flight: 'Flights',
      },
      quickLink: {
        featured: 'Featured',
        topHotels: 'Top hotels',
        district: 'Business area',
      },
      trainExpert: {
        trainChangeRefund: 'Flexible changes',
        trainQuickTicketIssuance: 'Fast ticketing',
        trainService: '24/7 support',
      },
    },
    travelSearch: {
      searchPlaceholder: 'Search hotels/locations in {city}',
      searching: 'Searching…',
      noResults: 'No results found',
      noResultsHint: 'Try a different keyword',
      searchHistory: 'Recent searches',
      emptyHint: 'Search hotels, landmarks or cities',
      cancel: 'Cancel',
      citySection: 'Cities',
      poiSection: 'Landmarks',
      hotelSection: 'Hotels',
      scoreLabel: '',
      priceFrom: 'from',
      loadMore: 'Load more',
      hotelNearbyHint: 'Hotels in and around the current destination (prices are for reference)',
      hotelOtherHint: 'Other results (hotel prices are for reference)',
      typeHotel: 'Hotel',
      typePoi: 'Landmark',
      typeCity: 'City',
    },
    orderList: {
      searchOrders: 'Search orders',
      filter: 'Filter',
      tab: {
        all: 'All',
        valid: 'Active',
        pendingPay: 'Unpaid',
        refund: 'Refunds',
      },
      filterBookingTime: 'Booking time',
      filterProductType: 'Product type',
      filterReset: 'Reset',
      filterConfirm: 'Apply',
      tabHome: 'Home',
      tabOrders: 'Orders',
      combinedOrderFilter: 'Bundle order',
    },
    orderSearch: {
      placeholder: 'City name or order no.',
      historyTitle: 'Recent searches',
      clearHistory: 'Clear',
      categoryTitle: 'Search by type',
    },
    orderPage: {
      orderType: {
        plane: 'Flight',
        intlPlane: 'Intl. flight',
        hotel: 'Hotel',
        train: 'Train',
        combined: 'Bundle',
        cart: 'Cart order',
      },
      metaTo: 'to',
      departFrom: 'departs',
      duration: '{duration}',
      nightsRooms: '{nights} night(s), {rooms} room(s)',
      hotelTag: 'Hotel:',
      unionOrderBadge: 'Bundle',
      bookAgain: 'Book again',
      cancelOrder: 'Cancel order',
      applyRefund: 'Request refund',
      refundProgress: 'Refund status',
      issueInvoice: 'Get invoice',
      viewInvoice: 'View invoice',
      goPay: 'Pay now',
      cartOrderItemCount: '{count} items',
      refundPassengers: 'Passengers to refund',
      nextStep: 'Next',
      unsubscribe: 'Cancel booking',
      unsubscribePlane: 'Cancel flight',
      unsubscribePlaneDesc: 'Add-ons can be cancelled together',
      unsubscribeOr: 'Or cancel add-ons only',
      unsubscribeInsurance: 'Cancel insurance',
      trainInvoiceList: 'Train invoices',
      invoiceFallback: 'Invoice',
      invoiceAmount: 'Amount: ¥{amount}',
      noTrainInvoice: 'No train invoices',
      selectInvoiceType: 'Select invoice type',
      ticketInvoice: 'Flight invoice',
      insuranceInvoice: 'Insurance invoice',
      insuranceInvoiceList: 'Insurance invoices',
      noInsuranceInvoice: 'No insurance invoices',
      outbound: 'Outbound',
      returnTrip: 'Return',
      journeyLeg: 'Leg {n}',
      changePersonCount: '{count} rebooked',
      hotelRefundPending:
        'This booking is not confirmed yet. Cancellation may incur fees. Contact support',
      hotelRefundPhone: '4007659936 ext. 1001',
      hotelRefundSuffix: ' for help',
      pendingPayStatus: 'Unpaid',
      loading: 'Loading',
      toast: {
        noInvoiceData: 'No invoice data',
        invoiceListFailed: 'Failed to load invoices',
        noInsuranceInvoice: 'No insurance invoices',
        insuranceInvoiceFailed: 'Failed to load insurance invoices',
        cancelSuccess: 'Cancelled',
        cancelFailed: 'Cancel failed',
        deleteSuccess: 'Deleted',
        refundSuccess: 'Refund requested',
        changingNoRefund: 'Refunds unavailable while changing',
        noRefundableTickets: 'No refundable tickets',
        noRefundableTicketProgress: 'No refundable tickets available',
        confirmCancel: 'Cancel this order?',
        confirmDelete: 'Delete this order?',
        confirmTitle: 'Notice',
        cancelCombinedTitle: 'Cancel bundle order',
        cancelCombinedMsg:
          'Cancel this bundle? Train/flight and hotel bookings will all be cancelled.',
        confirmRefund: 'Confirm refund',
        cancel: 'Cancel',
        refundReason: 'Refund',
        interceptRefundApplyMsg:
          'After you submit an intercept request, a successful intercept will result in a full refund. If the intercept fails, you may still travel or submit a refund request again.',
        cartOrderInvalid: 'Invalid order information',
        cartOrderPayLinkFailed: 'Failed to get the payment link, please try again later',
      },
    },
  },
  components: {
    selectDate: {
      title: 'Select date',
      tips: 'Dates are in origin local time; prices change often—final fare at payment applies',
      invalidOrder: 'Selected date does not follow the trip order',
    },
    waterFall: {
      loading: 'Loading…',
      noMore: 'No more results',
      unknownHotel: 'Unknown hotel',
      tagFallback: 'Tag',
    },
    zeroLoading: {
      loading: 'Loading…',
      wait: 'Please wait',
    },
  },
  unionPoint: {
    orderFill: {
      title: 'UnionPay points',
      unavailable: 'Unavailable',
      balanceHint: 'Balance {count} pts',
      inputPlaceholder: 'Up to {count} pts',
      useMax: 'Use all',
      unit: 'pts',
      rulesTitle: 'Rules',
      ruleOffset: 'Redemption ratio {ratio}',
      ruleMax: 'Max discount {amount} CNY per order',
      ruleMinUse: 'Minimum {count} pts per use',
      unavailableOverSaleprice: 'Order amount must exceed {amount} CNY to use points',
      inputMinHint: 'At least {count} pts required when using points',
      calculating: 'Calculating…',
      deductLine: 'UnionPay points',
      deductWithRate: 'UnionPay points 1 pt = {amount} CNY',
      priceDetailLine: 'UnionPay points discount',
    },
    redemptionRules: {
      link: 'Jileyou UnionPay Points Redemption Rules',
      title: 'Jileyou UnionPay Points Redemption Rules',
      sections: [
        {
          title: '1. Overview',
          paragraphs: [
            'UnionPay Points Redemption is a payment discount feature jointly offered by Jileyou and UnionPay. At checkout, you may use points in your UnionPay account to reduce the order amount. The remaining payable amount may still qualify for interest-free credit card installments.',
          ],
        },
        {
          title: '2. Point source and disclaimer',
          paragraphs: [
            'Points consumed through this feature are assets in your UnionPay APP account and are deducted in real time when you redeem.',
            'Point accrual, balance inquiry, validity, and account status are governed by UnionPay official rules. Jileyou does not issue or manage points.',
            'Jileyou only provides the redemption channel and is not responsible for point ownership, validity, expiry, or account anomalies.',
            'Please confirm your UnionPay point balance and intent before redeeming. Once confirmed, points are deducted immediately and cannot be reversed except in refund scenarios.',
          ],
        },
        {
          title: '3. Applicable scenarios',
          paragraphs: [
            'Point redemption is supported across Jileyou, including flights, hotels, tickets, and other services.',
            'At checkout, the deductible amount is calculated and displayed automatically based on your balance.',
            'Maximum deduction per order is CNY 100. The actual amount shown at checkout prevails.',
          ],
        },
        {
          title: '4. How to redeem',
          paragraphs: [
            'You may choose whether to use points and how much to apply, up to the displayed cap.',
            'The actual deductible amount is limited by the lower of:',
          ],
          listItems: [
            'The system-calculated amount (including the CNY 100 per-order cap)',
            'Your current UnionPay point balance',
          ],
          paragraphsAfter: [
            'If your balance is insufficient, the available amount is applied and the order can still be paid.',
            'After confirmation, points are deducted from your UnionPay account immediately.',
          ],
        },
        {
          title: '5. Interest-free installments',
          paragraphs: [
            'The remaining payable amount after point deduction may qualify for interest-free credit card installments.',
            'All Jileyou scenarios support installments; available terms are shown on product/checkout pages.',
          ],
        },
        {
          title: '6. Rules and limits',
          paragraphs: [
            'Frequency: up to 3 redemptions per person per day.',
            'Cap: up to CNY 100 point deduction per order.',
            'Stacking: point deduction may be combined with other promotions, coupons, and discounts.',
          ],
        },
        {
          title: '7. Refunds',
          paragraphs: [
            'Full refund: deducted points are returned to your UnionPay account.',
            'Partial refund: points are returned in proportion to the refunded amount.',
            'Return timing follows UnionPay processing, typically 1–3 business days.',
          ],
        },
        {
          title: '8. Notes',
          paragraphs: [
            'Points are UnionPay account assets. Keep your account secure; losses from misuse are your responsibility.',
            'Jileyou is not liable for deduction failures or delays due to UnionPay maintenance or outages, but will assist in communication with UnionPay.',
            'Matters not covered here are subject to UnionPay official rules and Jileyou platform agreements.',
            'Jileyou may update these rules with notice on the platform; continued use constitutes acceptance.',
          ],
        },
      ],
    },
  },
}
